'use strict';

DoohApps
    .factory('DeviceHelper', ['$filter', '$rootScope', 'DialogHandler', 'MediaScreenBLL', function ($filter, $rootScope, DialogHandler, mediaScreen) {
        return {
            SwitchDeviceTab: function (scope, tab, formHelper) {
                scope.deviceTabs.Active = tab;
                switch (tab) {
                    case 'Basic':
                        scope.deviceTabs.Active = 'Basic';
                        break;
                    case 'Settings':
                        formHelper.ResetFormErrors();
                        scope.ScreenDetailsForm = {
                            Title: scope.ScreenConfigDetails.Screen.ScreenTitle,
                            Description: scope.ScreenConfigDetails.Screen.Description,
                            IsTestDevice: scope.ScreenConfigDetails.IsTestDevice == null ? false : scope.ScreenConfigDetails.IsTestDevice,
                            MediaID: scope.ScreenConfigDetails.MediaID,
                            Location: scope.ScreenConfigDetails.Screen.Address,
                            Color: scope.ScreenConfigDetails.Screen.Color
                        };
                        break;
                    case 'Logs':
                        scope.dataLoading = true;
                        scope.LogDownloading = false;

                        resetLogFilterDates(scope.logFilter);

                        formatLogDate(scope.logFilter);

                        mediaScreen.LoadLog(function (data) {
                            scope.dataLoading = false;
                            if (data.hasError) {
                                DialogHandler.AddError('Could not load log!');
                            }
                            else {
                                scope.LogData = data.content;
                                scope.showLog = (scope.LogData.length != 0);
                                scope.MoreLogs = !(scope.LogData.length < scope.logFilter.count);
                            }
                            scope.deviceTabs.Active = 'Logs';
                        }, scope.logFilter);

                        break;
                    case 'Configuration':
                        loadConfiguration(scope, true);
                        break;
                }
            },
            DownloadLog: function (scope) {
                if (scope.LogDownloading) return;
                if (scope.LogData.length == 0) {
                    DialogHandler.AddMessage('There is nothing to download.', true);
                }
                else {
                    formatLogDate(scope.logFilter);
                    mediaScreen.DownloadLog(scope.logFilter);
                }
            },
            LoadMoreLogEntries: function (scope, count) {
                if (((scope.deviceTabs != undefined && scope.deviceTabs.Active == 'Logs') || (scope.groupTabs != undefined && scope.groupTabs.Active == 3)) && isFilterValid(scope.logFilter)) {
                    scope.dataLoading = true;
                    scope.logFilter.count = (count == undefined) ? scope.logFilter.count + 6 : count;
                    formatLogDate(scope.logFilter);

                    mediaScreen.LoadLog(function (data) {
                        scope.dataLoading = false;
                        if (data.hasError) {
                            DialogHandler.AddError('Could not load log!');
                        }
                        else {
                            scope.LogData = data.content;
                            scope.showLog = (scope.LogData.length != 0);
                            scope.MoreLogs = !(scope.LogData.length < scope.logFilter.count);
                        }
                    }, scope.logFilter);
                }
            },
            ResetLogFilterDates: function (scope) {
                resetLogFilterDates(scope.logFilter);
            },
            FormatLogDate: function (scope) {
                formatLogDate(scope.logFilter);
            },
            LoadConfiguration: loadConfiguration
        }

        function loadConfiguration(scope, switchTab) {
            mediaScreen.LoadSettings(function (data) {
                scope.DeviceConfiguration = data;
                if (switchTab)
                    scope.deviceTabs.Active = 'Configuration';
            }, scope.logFilter.MediaDeviceID);
        }

        function resetLogFilterDates(logFilter) {
            logFilter._dateFrom = moment().subtract(7, 'days').format($rootScope.SHORT_DATE_MOMENT);
            logFilter._dateTo = moment().format($rootScope.SHORT_DATE_MOMENT);
        }

        function formatLogDate(logFilter) {
            logFilter.dateFrom = moment(logFilter._dateFrom, $rootScope.SHORT_DATE_MOMENT).format('YYYY-MM-DD');
            logFilter.dateTo = moment(logFilter._dateTo, $rootScope.SHORT_DATE_MOMENT).format('YYYY-MM-DD');
        }

        function isFilterValid(logFilter) {
            if (moment(logFilter._dateFrom, $rootScope.SHORT_DATE_MOMENT).diff(moment(logFilter._dateTo, $rootScope.SHORT_DATE_MOMENT), 'days') > 0) {
                DialogHandler.AddError('End date should be greater than start date.');
                return false;
            }
            return true;
        }
    }]);